import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../api/api';
import { InventoryItem } from '../../types';

interface InventoryState {
  items: InventoryItem[];
  loading: boolean;
}

export const fetchInventory = createAsyncThunk('inventory/fetchAll', async () => {
  const res = await api.get<InventoryItem[]>('/inventory');
  return res.data;
});

export const createInventoryItem = createAsyncThunk('inventory/create', async (data: any) => {
  const res = await api.post<InventoryItem>('/inventory', data);
  return res.data;
});

export const updateInventoryItem = createAsyncThunk(
  'inventory/update',
  async ({ id, data }: { id: number; data: any }) => {
    const res = await api.put<InventoryItem>(`/inventory/${id}`, data);
    return res.data;
  }
);

export const deleteInventoryItem = createAsyncThunk('inventory/delete', async (id: number) => {
  await api.delete(`/inventory/${id}`);
  return id;
});

const inventorySlice = createSlice({
  name: 'inventory',
  initialState: { items: [], loading: false } as InventoryState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventory.pending, (state) => { state.loading = true; })
      .addCase(fetchInventory.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchInventory.rejected, (state) => { state.loading = false; })
      .addCase(createInventoryItem.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })
      .addCase(updateInventoryItem.fulfilled, (state, action) => {
        const idx = state.items.findIndex((i) => i.id === action.payload.id);
        if (idx !== -1) state.items[idx] = action.payload;
      })
      .addCase(deleteInventoryItem.fulfilled, (state, action) => {
        state.items = state.items.filter((i) => i.id !== action.payload);
      });
  },
});

export default inventorySlice.reducer;
